<div
    style="height: 100%; width: 100%;"
    #unauthorisedReactComponent
  ></div>